import React from 'react';
import { PhoneIcon, MessageSquareIcon } from 'lucide-react';
const TopBar = () => {
  return <div className="bg-gray-800 text-white py-2 px-4" data-id="element-359">
      <div className="container mx-auto flex justify-end items-center gap-3" data-id="element-360">
        <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-amber-500 hover:bg-amber-600 px-3 py-1 rounded transition-colors" data-id="element-361">
          <span className="font-medium" data-id="element-362">Book Now</span>
        </a>
        <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-burgundy-600 hover:bg-burgundy-700 px-3 py-1 rounded transition-colors" data-id="element-363">
          <MessageSquareIcon size={16} data-id="element-364" />
          <span className="font-medium" data-id="element-365">Enquire Now</span>
        </a>
        <a href="tel:07481300600" className="flex items-center gap-2 bg-burgundy-600 hover:bg-burgundy-700 px-3 py-1 rounded transition-colors" data-id="element-366">
          <PhoneIcon size={16} data-id="element-367" />
          <span className="font-medium" data-id="element-368">Call Now: 07481 300 600</span>
        </a>
      </div>
    </div>;
};
export default TopBar;